import { createContext, useState } from 'react';
import dateFormat from 'dateformat';
import { TaskBranchInfo, TaskDescription } from '../models/dashboard-models';

interface RequestContextProps {
    tasksBranchesInfo: TaskBranchInfo[];
    setTasksBranchesInfo: React.Dispatch<React.SetStateAction<TaskBranchInfo[]>>;
    taskDescription: TaskDescription;
    setTaskDescription: React.Dispatch<React.SetStateAction<TaskDescription>>;
    showModal: boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const RequestContext = createContext({} as RequestContextProps);

export const RequestProvider: React.FC = ({ children }) => {
    const [taskDescription, setTaskDescription] = useState({
        targetDate: dateFormat(new Date(), 'yyyy-mm-dd'),
    } as TaskDescription);
    const [tasksBranchesInfo, setTasksBranchesInfo] = useState([] as TaskBranchInfo[]);
    const [showModal, setShowModal] = useState(false);

    return (
        <RequestContext.Provider
            value={{
                taskDescription,
                setTaskDescription,
                tasksBranchesInfo,
                setTasksBranchesInfo,
                showModal,
                setShowModal,
            }}
        >
            {children}
        </RequestContext.Provider>
    );
};
